import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react';

import { Box } from 'core/components';
import TabbedChart from 'app/components/tabbedChart/TabbedChart';
import Page from 'app/components/page/Page';
import AggregateViewHeader from 'app/views/core/aggregate/AggregateViewHeader';
import parentLinks from 'app/views/core/NetworkExplorerParentLink';
import InsightsMenu from 'app/components/navbar/InsightsMenu';
import { SitesTable } from 'app/views/core/SitesTable';

const _Sites = () => {
  const [aggregateType, setAggregateType] = useState('p95th_bits_per_sec');
  const [filters, setFilters] = useState([]);
  const [lookbackSeconds, setLookbackSeconds] = useState(86400);

  const handleFiltersApply = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  const handleLookbackChange = useCallback((newLookbackSeconds) => {
    setLookbackSeconds(newLookbackSeconds);
  }, []);

  const handleAggregationChange = useCallback((newAggregateType) => {
    setAggregateType(newAggregateType);
  }, []);

  const queryOverrides = {
    aggregateTypes: [aggregateType],
    lookback_seconds: lookbackSeconds,
    topx: 350,
    depth: 350
  };

  return (
    <Page
      title="Sites"
      parentLinks={parentLinks}
      scrolls
      showExport
      insightsMenu={<InsightsMenu query="fetchSiteInsights" />}
    >
      <AggregateViewHeader
        title="Sites"
        aggregateType={aggregateType}
        filters={filters}
        lookbackSeconds={lookbackSeconds}
        onFiltersChange={handleFiltersApply}
        onAggregateChange={handleAggregationChange}
        onMetricsChange={handleAggregationChange}
        onTimeRangeChange={handleLookbackChange}
      />

      <Box>
        <TabbedChart
          overrides={queryOverrides}
          simpleFilters={filters}
          metrics={{
            Internal: 'i_device_site_name',
            Inbound: 'i_device_site_name',
            Outbound: 'i_device_site_name',
            Through: 'i_device_site_name'
          }}
          showNativeLegend
        />
      </Box>

      <SitesTable lookbackSeconds={lookbackSeconds} aggregateType={aggregateType} filters={filters} />
    </Page>
  );
};

const Sites = observer(_Sites);

export default Sites;
